import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const proyectopdet = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/proyectopdet`,
    state: {
        pilares: [],
        estados: []
    }
}).get({
    action: "get_proyectosbypilares",
    path: function (obj) {
        return `/groupbypilares/${obj.idsubregion}`;
    },
    onSuccess: (state, payload) => {
        state.pilares = payload.data;
    }
}).get({
    action: "get_estadosbysubregiones",
    path: function (obj) {
        return `/groupbyestados/${obj.idsubregion}`;
    },
    onSuccess: (state, payload) => {
        state.estados = payload.data;
    }
}).getStore();

proyectopdet.getters = {
    gproyectosbypilares: state => {
        return state.pilares
    },
    gestadosbysubregiones: state => {
        return state.estados
    }
}
export default proyectopdet;
